import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Mail, Lock, AlertCircle, Info } from 'lucide-react';
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState<'idle' | 'error' | 'locked' | 'pending'>('idle');
  return <div className="min-h-screen bg-background flex items-center justify-center p-6" data-id="element-5596">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-md" data-id="element-5597">
        <div className="flex flex-col items-center mb-8" data-id="element-5598">
          <Link to="/" className="flex items-center gap-2 mb-6" data-id="element-5599">
            <span className="text-2xl font-bold tracking-tight text-textMain" data-id="element-5600">
              Booker
            </span>
            <div className="w-2 h-2 rounded-full bg-primary mt-1" data-id="element-5601"></div>
          </Link>
          <h1 className="text-2xl font-bold text-textMain mb-2" data-id="element-5602">
            Welcome back
          </h1>
          <p className="text-textMuted text-sm" data-id="element-5603">
            Log in to your Booker account
          </p>
        </div>

        <div className="bg-surface border border-border rounded-xl p-6 shadow-xl" data-id="element-5604">
          {status === 'error' && <div className="mb-6 p-3 bg-red-500/10 border border-red-500/20 rounded-lg flex items-start gap-3" data-id="element-5605">
              <AlertCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-5606" />
              <p className="text-sm text-red-500" data-id="element-5607">
                Invalid email or password. Please try again.
              </p>
            </div>}
          {status === 'locked' && <div className="mb-6 p-3 bg-red-500/10 border border-red-500/20 rounded-lg flex items-start gap-3" data-id="element-5608">
              <Lock className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-5609" />
              <p className="text-sm text-red-500" data-id="element-5610">
                Account locked due to too many failed attempts. Please reset
                your password.
              </p>
            </div>}
          {status === 'pending' && <div className="mb-6 p-3 bg-amber-500/10 border border-amber-500/20 rounded-lg flex items-start gap-3" data-id="element-5611">
              <Info className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" data-id="element-5612" />
              <p className="text-sm text-amber-500" data-id="element-5613">
                Please verify your email address before logging in.
              </p>
            </div>}

          <form className="space-y-4 mb-6" onSubmit={e => e.preventDefault()} data-id="element-5614">
            <div data-id="element-5615">
              <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5616">
                Email
              </label>
              <div className="relative" data-id="element-5617">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-textMuted" data-id="element-5618" />
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-10 pr-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors" placeholder="you@example.com" data-id="element-5619" />
              </div>
            </div>
            <div data-id="element-5620">
              <div className="flex items-center justify-between mb-1.5" data-id="element-5621">
                <label className="block text-sm font-medium text-textMuted" data-id="element-5622">
                  Password
                </label>
                <Link to="/forgot-password" className="text-xs text-primary hover:text-primaryHover transition-colors" data-id="element-5623">
                  Forgot password?
                </Link>
              </div>
              <div className="relative" data-id="element-5624">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-textMuted" data-id="element-5625" />
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 pr-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors" placeholder="••••••••" data-id="element-5626" />
              </div>
            </div>
            <button className="w-full py-2.5 bg-primary text-background rounded-lg font-medium hover:bg-primaryHover transition-colors shadow-[0_0_15px_rgba(245,158,11,0.2)]" data-id="element-5627">
              Log in
            </button>
          </form>

          <div className="relative mb-6" data-id="element-5628">
            <div className="absolute inset-0 flex items-center" data-id="element-5629">
              <div className="w-full border-t border-border" data-id="element-5630"></div>
            </div>
            <div className="relative flex justify-center text-xs" data-id="element-5631">
              <span className="bg-surface px-2 text-textMuted" data-id="element-5632">
                Or continue with
              </span>
            </div>
          </div>

          <div className="space-y-3 mb-6" data-id="element-5633">
            <button className="w-full py-2.5 bg-background border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors flex items-center justify-center gap-2" data-id="element-5634">
              <svg className="w-4 h-4" viewBox="0 0 24 24" data-id="element-5635">
                <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-5636" />
                <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-5637" />
                <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-5638" />
                <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-5639" />
              </svg>
              Continue with Google
            </button>
            <button className="w-full py-2.5 bg-background border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors flex items-center justify-center gap-2" data-id="element-5640">
              <svg className="w-4 h-4" viewBox="0 0 24 24" data-id="element-5641">
                <path fill="currentColor" d="M11.4 24H0V12.6h11.4V24zM24 24H12.6V12.6H24V24zM11.4 11.4H0V0h11.4v11.4zm12.6 0H12.6V0H24v11.4z" data-id="element-5642" />
              </svg>
              Continue with Microsoft
            </button>
          </div>

          <button className="w-full py-2.5 bg-transparent border border-transparent rounded-lg text-sm font-medium text-textMuted hover:text-textMain hover:bg-background transition-colors" data-id="element-5643">
            Email me a magic link
          </button>
        </div>

        <p className="text-center text-sm text-textMuted mt-6" data-id="element-5644">
          Don't have an account?{' '}
          <Link to="/signup" className="text-primary hover:text-primaryHover font-medium transition-colors" data-id="element-5645">
            Sign up
          </Link>
        </p>
      </motion.div>
    </div>;
}